import React from 'react';
import HomeContainer from '../modules/Home/HomeContainer';
import appConfig from '../../app-config';
import MenuContainer from '../modules/Menu/MenuContainer';
import {Redirect} from '@reach/router';

const environment = process.env.GATSBY_ENV;

let redirectTo = `/${appConfig.pathPrefix}/menu`;

if (environment === 'development') {
  redirectTo = '/menu';
}

const HomePage = () =>
  appConfig.isRedirectedToMenuPage ? (
    <Redirect noThrow to={redirectTo} />
  ) : (
    <HomeContainer />
  );

export default HomePage;
